<template>
  <div class="sb-navigation">
    <div class="position-relative py-3">
      <div
        v-for="(nav, nav_idx) in disclosures"
        :key="`navigation-group-${nav_idx}-${nav.link}`"
        class="navigation-group"
      >
        <template v-if="nav.type == 'title'">
          <div
            v-if="nav.title_lv === 1"
            :class="['d-block align-items-center custom-padding-left', nav_idx > 0 ? 'mt-4' : '']"
          >
            <h5
              class="nav-title nav-title--parent"
              :class="{ 'is-english': lang === 'ENG' }"
              :data-observe-anchor="'title_' + nav.link"
            >
              <b-link
                class="nav-anchor text-keep-all text-decoration-none"
                @click="scroll_to_title(nav.link)"
              >
                <span v-show="lang === 'KOR'">{{ removeBackticks(nav.title1) }}</span>
                <span v-show="lang === 'ENG'">{{
                  removeBackticks(nav.title1_em ? nav.title1_em : nav.title1_ea)
                }}</span>
              </b-link>
            </h5>
          </div>
          <div v-if="nav.title_lv === 2">
            <h6
              :class="[
                'nav-title nav-title--child',
                '',
                'custom-padding-left',
                { 'is-english': lang === 'ENG' }
              ]"
              :data-observe-anchor="'title_' + nav.link"
            >
              <b-link
                class="nav-anchor text-keep-all text-decoration-none"
                @click="scroll_to_title(nav.link)"
              >
                <span v-show="lang === 'KOR'">{{ removeBackticks(nav.title1) }}</span>
                <span v-show="lang === 'ENG'">{{
                  removeBackticks(nav.title1_em ? nav.title1_em : nav.title1_ea)
                }}</span>
              </b-link>
            </h6>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'StoryBoardTocViewer',
  props: {
    disclosures: { type: Array, default: null }
  },
  computed: {
    ...mapState('report_list', ['lang']),
    ...mapGetters('story_board', ['selected_lv2']),
    ...mapGetters('report_list', ['selected_report']),
    anchorList() {
      if (!this.disclosures) return;
      return this.disclosures.reduce((_anchors, navEle) => {
        if (navEle?.title_lv < 3) {
          _anchors.push(`#title_${navEle.link}`);
        }

        return _anchors;
      }, []);
    }
  },
  watch: {
    disclosures_loaded: {
      immediate: true,
      handler(newV) {
        if (newV) {
          setTimeout(() => {
            this.handle_toc_scroll();
          }, 500);
        }
      }
    },
    disclosures: {
      immediate: true,
      handler(newV) {
        if (newV && newV.length > 0) {
          this.handle_toc_scroll();
          if (newV?.children && this.anchorList.length > 0) {
          }
        }
      }
    }
  },
  beforeDestroy() {
    if (this.anchorObserver) {
      this.anchorObserver.disconnect();
      this.anchorObserver = null;
    }
  },
  data() {
    return {
      activatedAnchor: null,
      anchorObserver: null,
      observeDealyTimeSleep: 0
    };
  },
  methods: {
    handlerObserveAnchor(entries, observer) {
      if (entries.length) {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const _navToAnchor = document.querySelectorAll(
              `[data-observe-anchor="${entry.target.id.replace(/#/g, '')}"]`
            );
            if (_navToAnchor.length) {
              const boundingRect = _navToAnchor[0].getBoundingClientRect();
              const offsetTop =
                boundingRect.top -
                document.querySelector('.sb-navigation').getBoundingClientRect().top;
              const _activedNavs = document.querySelectorAll('.navigation-indicator');
              if (_activedNavs.length) {
                _activedNavs.forEach(_activedNav => {
                  _activedNav.classList.remove('navigation-indicator');
                  _activedNav.style.borderRight = '';
                });
              }
              this.activatedAnchor = entry.target.id.replace(/#/g, '');
              const color = this.selected_report?.main_color;
              if (color) {
                const node = _navToAnchor[0].childNodes[0];
                node.classList.add('navigation-indicator');
                node.style.borderRight = `4px solid ${color}`;
              }
            }
          }
        });
      }
    },

    handle_toc_scroll() {
      if (!this.anchorList) return;
      this.observeDealyTimeSleep = 500;

      setTimeout(() => {
        // 기존에 실행 중인 옵저버가 있다면 연결을 해제합니다.
        if (this.anchorObserver) {
          this.anchorObserver.disconnect();
        }

        // --- 수정 시작 ---
        // 깨끗한 상태를 위해 기존 인디케이터를 모두 제거합니다.
        const currentIndicators = document.querySelectorAll('.navigation-indicator');
        currentIndicators.forEach(el => {
          el.classList.remove('navigation-indicator');
          el.style.borderRight = '';
        });

        // 첫 번째 부모 타이틀의 링크(<a>) 요소를 찾습니다.
        const firstParentAnchor = document.querySelector('.nav-title--parent .nav-anchor');
        if (firstParentAnchor) {
          // 기본 활성 항목으로 인디케이터 클래스와 스타일을 적용합니다.
          firstParentAnchor.classList.add('navigation-indicator');
          const color = this.selected_report?.main_color;
          if (color) {
            firstParentAnchor.style.borderRight = `4px solid ${color}`;
          }
        }
        // --- 수정 종료 ---

        // 스크롤에 따른 하이라이팅을 처리하기 위해 IntersectionObserver를 설정합니다.
        this.anchorObserver = new IntersectionObserver(this.handlerObserveAnchor, {
          rootMargin: '0% 0% -78.5% 0%',
          threshold: 1
        });

        this.anchorList.forEach(_anchor => {
          const _anchorTitle = document.querySelector(_anchor);
          if (_anchorTitle) {
            this.anchorObserver.observe(_anchorTitle);
          }
        });
      }, this.observeDealyTimeSleep);
    },
    scroll_to_title(link) {
      const element = document.getElementById('title_' + link);
      if (element) {
        element.style.scrollMarginTop = '100px';
        element.scrollIntoView({ behavior: 'auto' });
        history.pushState(null, null, '#title_' + link);
      }
    },
    removeBackticks(text) {
      if (!text) return '';
      return text.replace(/`/g, '');
    }
  }
};
</script>

<style scoped>
.custom-padding-left {
  padding-left: 15px;
  padding-right: 0px;
}

.navigation-group {
  gap: 30px;
}
</style>
